import { render, staticRenderFns } from "./SelectArray.vue?vue&type=template&id=556fc3c3&"
import script from "./SelectArray.vue?vue&type=script&lang=js&"
export * from "./SelectArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports